module.exports = __webpack_public_path__ + "static/google-logo-ff629c02385f2f3a199b7e0b3065d077.png";